import ReactDOM from 'react-dom/client';
import DynamicSelect from "../components/custom/DynamicSelect";
import dynamicSelectStore from "../stores/dynamicSelectStore";
import { ComponentContext } from "../contexts";

class EvaDynamicSelect extends HTMLElement {
  connectedCallback() {
    console.log("this", this);
    const store=new dynamicSelectStore(this.dataset);
    const root = ReactDOM.createRoot(this);
    root.render(
      <ComponentContext.Provider value={store}>
        <DynamicSelect {...this.dataset}/>
      </ComponentContext.Provider>
    );
  }
}
export default EvaDynamicSelect;